<template>
  <div v-if="post_detail">
    <div class="already-played denied" v-if="!scratchEnable">
      <div class="short-message">
        <h2><i class="fas fa-times-circle"></i><br>Please try with your mobile device</h2>
      </div>
    </div>
    <div class="cardviewscratch-main" :style="main_style" v-else-if="showGame">
      <div v-if="prizeItem" class="scratch">
        <div class="scratch-area">
          <div class="scratch-company-logo">
            <img class="mx-auto" :src="getdataImg(post_detail.logo_id)" /></div>
          <div class="scratch-company-logo scratch-title" v-if="!show_socials">
            <p style="font-weight: bold" :style="slogan_style">SCRATCH AND WIN</p>
            <p style="font-size: 18px" :style="award_style">SCRATCH OFF CAMPAIGNER™</p>
          </div>
            <scratch-surface :completed="setPlayed"
                           :showinfo="setShowInfo"
                           :show-scratch="true"
                           :show-socials="showSocials"
                           :expires="expireDate(post_detail.interaction.expire_date)"
                           :loaded="scratchLoaded"
                           :image_url="getdataImg(prizeItem.image_id)"
                           :code="prizeItem.code" :headline="prizeItem.claim"
                           id="scratchoff" :getPercentageCleared="true"
                           :percentageStride="100" class="scratch-off"
                           :brushOptions="{size: 30}"
                           :hideOptions="{src: scratch_cover_bg ,type: 'pattern', repeat: 'repeat', size: 'cover'}">
            <div class="content-so flex" :style="scratch_bg">
              <h2 v-if="prizeItem.text_enabled" :style="congrats_style">Congratulations!</h2>
              <h3 v-if="prizeItem.text_enabled">{{ prizeItem.name }}</h3>
              <img :src="getdataImg(prizeItem.image_id)" />
            </div>
          </scratch-surface>
          <div class="scratch-company-logo scratch-address" v-if="!show_socials">
            <div class="scratch-company-logo" :style="award_style">
              <a target="_blank" :href="post_detail.website"><img class="mx-auto" height="85px" :src="getdataImg(post_detail.company_logo)"  alt=""/></a>
            </div>
            <p :style="award_style" v-html="post_detail.address"></p>
            <p :style="award_style">
              <a :href="post_detail.website">{{post_detail.website.replace("https://","").replace("http://","")}}</a>
            </p>
          </div>
          <div class="social-links-wrap">
            <section v-if="show_socials && post_detail.scratchType==='quickly' && !sendEmail" class="form-area">
              <form data-vv-scope="interaction">
                <input type="email" placeholder="Email" v-model="email" style="">
                <div class="form-agreement">
                  <div class="form-agreement-check">
                    <div><input type="checkbox" v-model="check"/></div>
                    <div :style="campaign_theme ? privacy_primary : ''">I've read and understand the <a  :style="campaign_theme ? privacy_secondary : ''" class="cursor-pointer" @click="showPrivacy">{{ post_detail.company_name }}</a>'s Privacy Policy and <a :style="campaign_theme ? privacy_secondary : ''" href="https://authorizelocal.com/portal-privacy-policy/" target="_blank">Authorize Local</a>'s Privacy Policy</div>
                  </div>
                </div>
                <div :style="submit_style" class="al-button" @click.prevent="submitForm" >Send Code</div>
              </form>
            </section>
            <div class="congrats" v-if="sendEmail">
              <p  :style="congrats_style"><strong>Your reward code has been sent <br>to your email.</strong></p>
            </div>
            <social-links v-if="show_socials" :post_detail="post_detail" />
            <vue-bottom-sheet ref="sheet" class="form-bottom-sheet">
              <p v-html="post_detail.privacy"/>
            </vue-bottom-sheet>
          </div>
        </div>

      </div>

    </div>
    <div class="already-played denied" v-else-if="!scratchStatus">
      <div class="short-message">
        <h2><i class="fas fa-times-circle"></i><br>This campaign has been stopped.</h2>
      </div>
    </div>
    <div class="already-played denied" v-else>
      <div class="short-message">
      <h2><i class="fas fa-times-circle"></i><br>Already Played</h2>
      </div>
    </div>

  </div>
</template>
<script>

import VueScratchable from 'vue-scratchable'
import ScratchSurface from './pages/components/ScratchSurface'
import SocialLinks from './SocialLinks'
import moment from 'moment'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default {
  props: {
    slug: String
  },
  data () {
    return {
      check: false,
      scratchStatus: true,
      fingerprint: '',
      fieldnames: [
        {
          name: 'Name',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          value: false
        },
        {
          name: 'Address',
          code: 'address',
          value: false
        }
      ],
      sendEmail: false,
      name: '',
      email: '',
      birthday: '',
      phone: '',
      address: '',
      setupTime: new Date().getTime().toString(),
      nowTime: new Date().getTime(),
      sessiomInterval: null,
      post_detail: null,
      prizeItem: null,
      showPrize: false,
      showInfo: false,
      show_socials: false,
      scratchEnable: true,
      sessionid: (localStorage.getItem('sessionid') && localStorage.getItem('sessionid') !== 'undefined') ? localStorage.getItem('sessionid') : this.makeid(25)
    }
  },
  components: {
    VueScratchable,
    ScratchSurface,
    SocialLinks
  },
  async created () {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    this.fingerprint = result.visitorId
  },
  mounted () {
    if (this.slug) {
      this.getCard()
    }
  },
  destroyed () {
  },
  watch: {
  },
  computed: {

    award_style () {
      if (this.campaign_theme.award) {
        return `color: ${this.campaign_theme.award.color}; font-size: ${this.campaign_theme.award.size}px; font-weight: ${this.campaign_theme.award.weight};`
      } else {
        return ''
      }
    },
    slogan_style () {
      if (this.campaign_theme.slogan) {
        return `color: ${this.campaign_theme.slogan.color}; font-size: ${this.campaign_theme.slogan.size}px; font-weight: ${this.campaign_theme.slogan.weight};`
      } else {
        return ''
      }
    },
    privacy_secondary () {
      if (this.campaign_theme.privacy) {
        return `color: ${this.campaign_theme.privacy.secondary_color}; font-size: ${this.campaign_theme.privacy.secondary_size}px; font-weight: ${this.campaign_theme.privacy.secondary_weight};`
      } else {
        return ''
      }
    },
    privacy_primary () {
      if (this.campaign_theme.privacy) {
        return `color: ${this.campaign_theme.privacy.primary_color}; font-size: ${this.campaign_theme.privacy.primary_size}px; font-weight: ${this.campaign_theme.privacy.primary_weight};`
      } else {
        return ''
      }
    },
    submit_style () {
      if (this.campaign_theme.submit) {
        return `background: ${this.campaign_theme.submit.background}; color: ${this.campaign_theme.submit.color}; font-size: ${this.campaign_theme.submit.size}px; font-weight: ${this.campaign_theme.submit.weight};`
      } else {
        return ''
      }
    },
    congrats_style () {
      if (this.campaign_theme.congrats) {
        return `color: ${this.campaign_theme.congrats.color}; font-size: ${this.campaign_theme.congrats.size}px; font-weight: ${this.campaign_theme.congrats.weight};`
      } else {
        return ''
      }
    },
    main_style () {
      if (this.campaign_theme) {
        if (this.isObject(this.campaign_theme.main)) {
          return `background: url(${this.getImage(this.campaign_theme.main.url)})`
        } else if (this.campaign_theme.main !== '') {
          return `background: ${this.campaign_theme.main}`
        }
      }
      return ''
    },
    scratch_bg () {
      if (this.isObject(this.campaign_theme.scratch) && this.campaign_theme.scratch.url !== '') {
        return `background: url(${this.getImage(this.campaign_theme.scratch.url)})`
      } else if (this.campaign_theme.scratch !== '') {
        return `background: ${this.campaign_theme.scratch}`
      } else {
        return 'background: url("/scratchBack.jpeg")'
      }
    },
    scratch_cover_bg () {
      return this.campaign_theme.cover ? this.getImage(this.campaign_theme.cover) : '/default_scratch_texture.jpg'
    },
    campaign_theme () {
      return this.$store.state.campaign_theme
    },
    timeDiff () {

      let msec = this.nowTime - this.setupTime
      const hh = Math.floor(msec / 1000 / 60 / 60)
      msec -= hh * 1000 * 60 * 60
      const mm = Math.floor(msec / 1000 / 60)
      msec -= mm * 1000 * 60
      const ss = Math.floor(msec / 1000)
      msec -= ss * 1000

      return `${hh}:${mm}:${ss}`

      //return msec
    },
    showGame () {
      if (this.post_detail.interaction.is_played === false && this.post_detail.is_active) {
        return true
      }
      return false
    },
    isMobile () {
      return /Mobi|Android|iPhone/i.test(navigator.userAgent)
    }
  },
  methods: {
    showPrivacy () {
      if (!this.sheet) {
        this.$refs.sheet.open()
      } else {
        this.$refs.sheet.close()
      }
      this.sheet = !this.sheet
    },
    submitForm () {
      let custom_valid = true
      if (!this.email) {
        custom_valid = false
      } else {
        const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
        custom_valid = regex.test(this.email)
      }
      if (this.check && custom_valid) {
        const payload = {
          email: this.email,
          fingerprint: this.fingerprint,
          code: this.post_detail.interaction.code
        }
        this.$store.dispatch('updateInteraction', payload)
          .then((response) => {
            this.showPrize = true
            if (response.data.email === this.email) {
              this.sendEmail = true
            }
            //location.reload()
          })
          .catch(error => {
            this.$vs.loading.close()
            console.log(error)
          })
      } else if (!this.check) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please agree to terms of service',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fill up the form',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      }

    },
    expireDate (str) {
      console.log('ssss', str)
      return moment(str).format('MM/DD/YYYY hh:mm a')
    },
    scratchLoaded () {
    },
    isObject (a) {
      return (!!a) && (a.constructor === Object)
    },
    getImage (url) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${url}`
    },
    setPlayed () {
      const payload = {
        code: this.post_detail.interaction.code,
        fingerprint: this.fingerprint
      }
      this.$store.dispatch('setPlayed', payload)
        .then((response) => {
          console.log('success')
          console.log(response)
          this.showPrize = true
          //location.reload()
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error')
          console.log(error)
        })
    },
    setShowInfo () {
      this.showInfo = true
    },
    showSocials (value) {
      this.show_socials = value
    },
    makeid (length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    open_link (url) {
      window.open(url, '_blank')
    },
    checkSessionValid () {
      this.nowTime = new Date().getTime()
      let msec = this.nowTime - this.setupTime
      const hh = Math.floor(msec / 1000 / 60 / 60)
      msec -= hh * 1000 * 60 * 60
      const mm = Math.floor(msec / 1000 / 60)
      msec -= mm * 1000 * 60
      const ss = Math.floor(msec / 1000)
      msec -= ss * 1000

      console.log(`diff${msec}`, this.timeDiff)
      console.log('prize', this.prizeItem.name)
      if (hh === 0 && mm >= 30) {
        this.refreshSession()
      }

      if (!this.sessiomInterval) {
        this.sessiomInterval = setInterval(this.checkSessionValid, 1000 * 60)
      }

    },
    refreshSession () {
      console.log('refresing session')

      localStorage.removeItem('prize')
      localStorage.removeItem('session')
      localStorage.removeItem('setup')

      location.reload()
    },
    setupData () {
      const { campaign_theme } = JSON.parse(JSON.stringify(this.post_detail))
      this.prizeItem = this.post_detail.interaction.prize

      this.$store.commit('SET_CAMPAIGN_THEME', campaign_theme)
    },
    getdataImg (id) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${id}`
    },
    getCard () {
      const payload = {
        code: this.slug
      }
      this.$store.dispatch('getGame', payload)
        .then((response) => {
          this.post_detail = response.data.data
          if (this.post_detail.scratchType === 'quickly') {
            if (!this.isMobile) {
              this.scratchEnable = true
            }
          }
          if (this.post_detail.is_active) {
            this.setupData()
          } else {
            this.scratchStatus = false
          }
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss">
.social-links-wrap {
  width:385px;
}
.scratch-company-logo {
    margin-bottom:25px;
  }
.opacity-0 {
  opacity: 0;
}
.opacity-1 {
  opacity: 1;
}
.cardviewscratch-main {
  width: 100%;
  height: 100%;
  background-size:cover !important;
}
.scratch-blocker {
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index:3;
}
.submit-description {
  text-align:center;
  font-size:14px;
  font-weight:bold;
  margin-bottom:20px;
}
.already-played {
  width:100%;
  min-height: 100vh;
  display:flex;
  justify-content: center;
  align-items: center;
}
.denied{
    i {
      color:#c32429;
      font-size:42px;
    }
  }
  .short-message {
    h2{
      text-align: center;
    }
    display:flex;
    justify-content: center;
    align-items:center;
    font-size:32px;
    font-weight: 700;
    width:90%;
    padding:50px 20px;
    border-radius: 7px;
  }
.scratch-area{
  display: flex;
    flex-wrap: wrap;
    width: 300px;
    min-height: 50vh;
    justify-content: space-around;
    flex-direction: column;
    align-items: center;
    padding:50px 0px;
}
@media (max-width:768px){
.social-links-wrap {
  width:100%;
}
}
.scratch-title {
  font-size: 20px;
  font-weight: 400;
  text-align: center;
}
.scratch-address {
  font-weight: 400;
  text-align: center;
}
.mb-30 {
  margin-bottom: 30px;
}

.form-agreement{
  display:flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  font-size:11px;
  margin:0px 0;
  div{
    padding: 5px 5px 5px 0;
  }
  input {
    width:25px;
    height:25px;
    margin-bottom:0;
  }
  a {
    color:#f08028;
  }
  .al-button{
    font-size:26px;
  }
  .form-agreement-check{
    display:flex;
    justify-content: flex-start;
    align-items:center;
    font-size:9px;
    gap:5px;
  }
}
</style>
